export const STATUS_PENDENTE = 'Pendente';
export const STATUS_EM_TRIAGEM = 'Em Triagem';
export const STATUS_EM_CONTRATACAO = 'Em Contratação';
export const STATUS_AGUARDANDO_EXECUCAO = 'Aguardando Execução';
export const STATUS_EM_EXECUCAO = 'Em Execução';
export const STATUS_EM_CONFERENCIA = 'Em Conferência';
export const STATUS_FINALIZADA = 'Finalizada';
export const STATUS_CANCELADA = 'Cancelada';
export const STATUS_INTERROMPIDA = 'Interrompida';

export const STATUS_OPTIONS = [
    { value: STATUS_PENDENTE, label: 'Pendente' },
    { value: STATUS_EM_TRIAGEM, label: 'Em triagem' },
    { value: STATUS_EM_CONTRATACAO, label: 'Em contratação' },
    { value: STATUS_AGUARDANDO_EXECUCAO, label: 'Aguardando Execução' },
    { value: STATUS_EM_EXECUCAO, label: 'Em Execução' },
    { value: STATUS_EM_CONFERENCIA, label: 'Em Conferência' },
    { value: STATUS_FINALIZADA, label: 'Finalizada' },
] as const;

export const ORDERED_STATUSES: readonly string[] = [
    STATUS_PENDENTE,
    STATUS_EM_TRIAGEM,
    STATUS_EM_CONTRATACAO,
    STATUS_AGUARDANDO_EXECUCAO,
    STATUS_EM_EXECUCAO,
    STATUS_EM_CONFERENCIA,
    STATUS_FINALIZADA,
];

const STATUS_LABEL_MAP: Record<string, string> = {
    [STATUS_PENDENTE]: 'Pendente',
    [STATUS_EM_TRIAGEM]: 'Em Triagem',
    [STATUS_EM_CONTRATACAO]: 'Em Contratação',
    [STATUS_AGUARDANDO_EXECUCAO]: 'Aguardando Execução',
    [STATUS_EM_EXECUCAO]: 'Em Execução',
    [STATUS_EM_CONFERENCIA]: 'Em Conferência',
    [STATUS_FINALIZADA]: 'Finalizada',
    [STATUS_CANCELADA]: 'Cancelada',
    [STATUS_INTERROMPIDA]: 'Interrompida',
};

export const getStatusLabelDemanda = (status: string): string =>
    STATUS_LABEL_MAP[status] ?? status;
